import { action } from 'satcheljs/lib/legacy';
import { FloatingPeoplePicker } from 'office-ui-fabric-react/lib/FloatingPicker';
import {
    lazyCreateOrUpdateOptionsForFeature,
    OwsOptionsFeatureType,
    LinkedInBindingDismissedOptions,
} from 'owa-outlook-service-options';

export default action('saveLinkedInBindingDismissed')(async function saveLinkedInBindingDismissed(
    picker?: FloatingPeoplePicker
) {
    await lazyCreateOrUpdateOptionsForFeature.importAndExecute(
        OwsOptionsFeatureType.LinkedInBindingDismissed,
        {
            linkedInBindingDismissedInPeoplePicker: true,
        } as LinkedInBindingDismissedOptions
    );

    // Currently in order for picker to update we need to update the findresultset in viewstate
    // Or call forceUpdate picker.
    // After refactoring the fabric-RW, we need to use the proper way to make the floatingPeoplePicker properly
    // https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/42355
    if (picker) {
        picker.forceUpdate();
    }
});
